;(function($) {
  "use strict"
  $(function() {
    function setHeight() {
      for (let i = 1; i < 5; i++) {
        $(".js-equalizer" + i).css("height", "auto")
        let maxHeight2 = Math.max.apply(
          null,
          $(".js-equalizer" + i)
            .map(function() {
              return $(this).height()
            })
            .get()
        )
        $(".js-equalizer" + i).height(maxHeight2)
      }
    }
    $(window).on("load", function() {
      setHeight()
    })
    $(window).on("resize", function() {
      setHeight()
    })
    $(window).on("click", function() {
      setHeight()
    })
  })
})(jQuery)
